module.exports = __webpack_public_path__ + "static/media/allow-professions-black.8fe7aaf6.svg";